export default [
  {
    path: '/fishFesitivalCatagory',
    component: () => import('../pages/fesitival/fishFesitivalCatagory.vue'),
    name: 'fishFesitivalCatagory',
    title: '增绿减碳分类',
    meta: {
      title: '增绿减碳分类',
    },
  },
  {
    path: '/fishFesitivalManage',
    component: () => import('../pages/fesitival/fishFesitivalManage.vue'),
    name: 'fishFesitivalManage',
    title: '增绿减碳管理',
    meta: {
      title: '增绿减碳管理',
    },
  },
  {
    path: '/fishFesitivalCheck',
    component: () => import('../pages/fesitival/fishFesitivalCheck.vue'),
    name: 'fishFesitivalCheck',
    title: '审核',
    meta: {
      title: '审核',
    },
  },
]
